import { Dispatch, SetStateAction } from "react";

export type StartingDateFilterTypes = "soon" | "this-week" | "next-week";

export type RequestLengthFilterTypes = "single-day" | "multi-day" | "long-term";

export type RequestTypeFilterTypes = "worked-before" | "new-today";

export type LocalStorageFilterValueTypes = {
  startingDate: StartingDateFilterTypes[];
  requestLength: RequestLengthFilterTypes[];
  requestType: RequestTypeFilterTypes[];
};

export type ThreadedData = {
  ls: LocalStorageFilterValueTypes;
  setLs: Dispatch<SetStateAction<LocalStorageFilterValueTypes>>;
};

export const initialLocalStorageFilterValues: LocalStorageFilterValueTypes = {
  startingDate: [],
  requestLength: [],
  requestType: [],
};

export type UnifiedFilterType =
  | StartingDateFilterTypes
  | RequestLengthFilterTypes
  | RequestTypeFilterTypes;
